// extracted by mini-css-extract-plugin
export default {"base":"ActionRejected_base__sODja"};